import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import SuiInput from "components/SuiInput";
import DraggableDialog from "components/UpStyled/DraggableDialog";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PeopleIcon from "@mui/icons-material/People";
import FolderIcon from "@mui/icons-material/Folder";
import SearchIcon from "@mui/icons-material/Search";

import api from "services/api";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";
import AvatarComplex from "pages/de/share-page/components/AvatarComplex";

import { toast } from "react-hot-toast";
import typography from "assets/theme/base/typography";

const CollaboratorsListModal = ({
  handleClose,
  handleOk,
  visible,
  handleRefresh = () => {},
  permittedUsers = [],
  onAvatarClick = () => {},
}) => {
  const [searchStr, setSearchStr] = useState("");
  const [filteredUsers, setFilteredUsers] = useState(permittedUsers);

  const { size, fontWeightRegular } = typography;

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState({});

  const account = useContext(AccountContext);
  const { store } = useContext(StoreContext);

  const handleSearchChange = (e) => {
    let value = e?.target?.value || "";
    const lower = value.toLowerCase();
    setSearchStr(value);
    const userList = permittedUsers.filter((user) => {
      const email = user?.user?.email;
      const store =
        user?.user?.stores && user?.user?.stores.length > 0 ? user?.user?.stores[0] : {};

      return store?.name.toLowerCase().includes(lower) || email?.toLowerCase().includes(lower);
    });
    setFilteredUsers(userList);
  };

  return (
    <DraggableDialog
      heading={`Collaborators`}
      text={
        <SuiBox pt={0.5}>
          <SuiBox mx={2} mb={1}>
            <SuiInput
              placeholder="Search"
              icon={{
                direction: "right",
                component: <SearchIcon fontSize="small" />,
              }}
              onChange={handleSearchChange}
            />
          </SuiBox>
          <List
            sx={{ width: "100%", maxHeight: 360, overflow: "auto", bgcolor: "background.paper" }}
          >
            {filteredUsers.map((user, index) => {
              const email = user?.user?.email;
              const store =
                user?.user?.stores && user?.user?.stores.length > 0 ? user?.user?.stores[0] : {};

              return (
                <ListItemButton
                  alignItems="flex-start"
                  key={index}
                  onClick={(e) => onAvatarClick(e, user)}
                >
                  <ListItem secondaryAction={null}>
                    <ListItemAvatar>
                      <AvatarComplex
                        store={store}
                        size="lg"
                        sharedSessions={null}
                        iconColor="white"
                        icon={
                          user?.resource_type == "collection" ? (
                            <FolderIcon sx={{ width: 16, height: 16 }} color="info" />
                          ) : null
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={store?.name}
                      secondary={
                        <React.Fragment>
                          <SuiTypography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {email}
                          </SuiTypography>
                        </React.Fragment>
                      }
                    />{" "}
                  </ListItem>
                </ListItemButton>
              );
            })}
          </List>
        </SuiBox>
      }
      visible={visible}
      handleClose={() => {
        handleClose();
      }}
      handleOk={() => {
        handleClose();
        handleRefresh();
      }}
      okText="Done"
      cancelText={null}
      hideAction={false}
      option={{ fullWidth: true, maxWidth: "sm" }}
    />
  );
};

export default CollaboratorsListModal;
